import React, {Component} from 'react';
import _ from "lodash";
import {Form, Field, Control, Errors} from 'react-redux-form';
import FemaleProfile from './../../assets/images/user_profile_female.jpg';
import MaleProfile from "./../../assets/images/user_profile_male.jpg";
import {isEmail, minLength2, isRequired, required} from "../field_validations";
import GreetingsSelect from "../forms/greeting_select";

class ProfileForm extends Component {
	render() {
		let {isFetching} = this.props;
		return <Form
			onSubmit={this._handleSubmit}
			model="profile.edit"
			encType="multipart/form-data"
			validators={{
				'': {passwordsMatch: (vals) => vals.password === vals.password_confirmation}
			}}
			onSubmitFailed={
				(error) => 'Hay errores en el formulario'
			}>
			<div className="columns is-centered is-multiline">
				<div className="column is-8">
					<Errors model="profile.edit"
					        messages={{passwordsMatch: 'Las contraseñas no coinciden'}}
					        wrapper={(props) => <div className="notification is-danger">{props.children}</div>}
					/>
				</div>
				<div className="column is-8">
					<div className="columns">
						<div className="column is-3 has-text-centered">
							{this.props.edit.image ?
								(_.isObject(this.props.edit.image) ?
									<figure className="image is-1by1">
										<i className="fa fa-upload fa-4x" />
									</figure> :
									<figure className="image is-1by1">
										<img src={`${this.props.edit.image}?${Date.now()}`} alt={this.props.edit.name}/>
									</figure>) :
								(this.props.edit.sex === 'H' ?
										<figure className="image is-1by1">
											<img src={MaleProfile} alt={this.props.edit.name}/>
										</figure> :
										<figure className="image is-1by1">
											<img src={FemaleProfile} alt={this.props.edit.name}/>
										</figure>
								)
							}
							<br/>
							<div className="file">
								<label className="file-label">
									<Control.file className="file-input" type="file" name="image" id="image" model=".image" />
									<span className="file-cta">
										<span className="file-icon">
											<i className="fa fa-upload" />
										</span>
										<span className="file-label">Nueva imagen</span>
									</span>
								</label>
							</div>
						</div>
						<div className="column">
							<div className="field has-addons">
								<div className="control">
									<label htmlFor="title" className="label">Saludo <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control model=".title"
										         id="title"
										         component={GreetingsSelect}
										         validateOn="change"
										         errors={{required}}
										/>
									</div>
									<Errors model=".title"
									        show="touched"
									        wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									        messages={{required: 'Obligatorio'}}
									/>
								</div>
								<div className={`control is-expanded ${isFetching && 'is-loading'}`}>
									<label htmlFor="name" className="label">Nombre(s) <span className="small has-text-danger">*</span></label>
									<Control.text
										model=".name"
										id="name"
										className="input"
										disabled={isFetching}
										errors={{isRequired, minLength2}}
										validateOn="change"
										autoFocus={true}
									/>
									<Errors
										model=".name"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{
											isRequired: 'Debes ingresar tu nombre',
											minLength2: 'Tu nombre debe tener al menos 2 letras'
										}}
									/>
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control is-expanded ${isFetching && 'is-loading'}`}>
									<label htmlFor="last_name" className="label">Primer Apellido <span className="small has-text-danger">*</span></label>
									<Control.text
										model=".last_name"
										id="last_name"
										className="input"
										disabled={isFetching}
										errors={{isRequired}}
										validateOn="change"
									/>
									<Errors
										model=".last_name"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{isRequired: 'El apellido es obligatorio'}}
									/>
								</div>

								<div className={`control is-expanded ${isFetching && 'is-loading'}`}>
									<label htmlFor="slast_name" className="label">Segundo Apellido</label>
									<Control.text
										model=".slast_name"
										id="slast_name"
										disabled={isFetching}
										className="input"
									/>
								</div>
							</div>

							<div className="field is-grouped">
								<div className="control">
									<label htmlFor="sex" className="label">Sexo <span className="small has-text-danger">*</span></label>
									<Field
										model=".sex"
										id="sex"
										disabled={isFetching}
										className="select"
										errors={{required}}
										validateOn="change">
										<select id="sex">
											<option defaultValue disabled>--- Sexo ---</option>
											<option value="M">Mujer</option>
											<option value="H">Hombre</option>
										</select>
									</Field>
									<Errors
										model=".sex"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{required: 'El sexo es obligatorio'}}
									/>
								</div>

								<div className="control is-expanded">
									<label htmlFor="scholarship" className="label">Escolaridad</label>
									<Control.text model=".scholarship" className="input" id="scholarship" disabled={isFetching} />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="column is-8">
					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="email" className="label">Email principal <span className="small has-text-danger">*</span>
								<small className="has-text-grey is-small">(este e-mail es también tu usuario)</small>
							</label>
							<Control.text
								model=".email"
								id="email"
								disabled={isFetching}
								className="input"
								placeholder="usuario@dominio.com"
								errors={{required, isEmail}}
								validateOn="change"
							/>
							<Errors
								model=".email"
								show="touched"
								wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
								messages={{
									required: 'Debes ingresar un e-mail. ',
									isEmail: 'El email es inválido.'
								}}
							/>
						</div>
						<div className="control is-expanded">
							<label htmlFor="email_2" className="label">Email secundario</label>
							<Control.text
								model=".email_2"
								id="email_2"
								disabled={isFetching}
								className="input"
								type="email"
								placeholder="usuario@dominio.com"
								errors={{
									notEqual: (val) => val === this.props.edit.email,
									isEmail: (val) => !_.isEmpty(val) ? isEmail(val) : false
								}}
								show="touched"
							/>
							<Errors
								model=".email_2"
								wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
								messages={{
									isEmail: 'El email es inválido. ',
									notEqual: 'El email secundario debe ser diferente al principal. '
								}}
							/>
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="telephone" className="label">Teléfono</label>
							<Control.text
								model=".telephone"
								id="telephone"
								disabled={isFetching}
								className="input"
							/>
						</div>

						<div className="control">
							<label htmlFor="extension" className="label">Extensión</label>
							<Control.text model=".extension" className="input" id="extension" disabled={isFetching}/>
						</div>

						<div className="control is-expanded">
							<label htmlFor="telephone_2" className="label">Teléfono secundario</label>
							<Control.text model=".telephone_2" id="telephone_2" className="input"/>
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="password" className="label">Contraseña</label>
							<Control.password model=".password" id="password" name="password" className="input" placeholder="Contraseña" />
						</div>

						<div className="control is-expanded">
							<label htmlFor="password_confirmation" className="label">Confirmar contraseña</label>
							<Control.password model=".password_confirmation" id="password_confirmation" name="password_confirmation" className="input" />
						</div>
					</div>

					<div className="message is-dark is-small">
						<div className="message-body">
							Si no deseas alterar tu contraseña, deja en blanco los campos de contraseña.
						</div>
					</div>

					<div className="field is-grouped is-grouped-right">
						<div className="control">
							<button type="button" className="button is-danger" onClick={() => this.props.history.push('/usuarios')}>
								Regresar
							</button>
						</div>

						<div className="control">
							<Control.button
								model="profile.edit"
								className="button is-success"
								disabled={{pristine:true || isFetching}}>
								Guardar
							</Control.button>
						</div>
					</div>

					<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
						className="small has-text-danger">*</span> son obligatorios.</p>
				</div>
			</div>
		</Form>
	}

	_handleSubmit = (values, event) => {
		this.props.profileSave(values, event.target);
	}
}


export default ProfileForm;



// WEBPACK FOOTER //
// ./src/elements/profile/form.jsx